import React from 'react';
import HeaderFive from '../../components/Header/HeaderFive';
import ErrorMain from './ErrorMain';
import FooterThree from '../../components/Footer/FooterThree';

const Error = () => {
  return (
    <>
      <HeaderFive />

      <ErrorMain />

      <FooterThree />
    </>
  );
};

export default Error;
